/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_Body_6Inputs */

const en_wb_sales_body_6 = /** @type {(inputs: Wb_Sales_Body_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your team`)
};

const lv_wb_sales_body_6 = /** @type {(inputs: Wb_Sales_Body_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu komanda`)
};

/**
* | output |
* | --- |
* | "Your team" |
*
* @param {Wb_Sales_Body_6Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_body_6 = /** @type {((inputs?: Wb_Sales_Body_6Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_Body_6Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_body_6(inputs)
	return en_wb_sales_body_6(inputs)
});